"use client";

/**
 * Shared shape behind the patient and staff card capture success handlers:
 * confirm the just-completed Stripe setup, apply the card if one came back,
 * then always run `onConfirmed` — even on failure, since the error toast is
 * already surfaced by the mutation's global error handler.
 */
export function useCardCaptureConfirmHandler<TCard>(
  confirmCapture: (setupIntentId: string) => Promise<TCard | undefined>,
  onCardConfirmed: (card: TCard) => void,
  onConfirmed: VoidFunction,
) {
  return async (setupIntentId: string) => {
    try {
      const card = await confirmCapture(setupIntentId);
      if (card) {
        onCardConfirmed(card);
      }
    } catch {
      // Error toast is already surfaced by the mutation's global error handler.
    } finally {
      onConfirmed();
    }
  };
}
